import React from "react";
import { useSelector } from "react-redux";
import { Mixpanel } from "../utils/mixpanelIntegration";
import UserService from "../services/api/UserService";

const RetireePortalButton = () => {
  const { location } = useSelector((state) => ({
    location: state.homeReducer.location?.data,
  }));

  const isRetireesPage = () =>
    window.location.pathname === "/retirees";

  const shouldShowRetireePortalButton = () => {
    if (isRetireesPage()) {
      // On retirees page, only show if user navigated here via button click
      return localStorage.getItem('retireeNavigationSource') !== null;
    }

    // On other pages, only show if location has retiree portal enabled
    return location?.location_has_retiree_portal;
  };

  const handleClick = () => {
    // Cross origin (i.e, miiameber and miiamedicare) can not use localstorae, the code will use params (clean after the transfer)
    console.log('Retiree Portal clicked!', location);

    // If already on retirees page, navigate back to source
    if (isRetireesPage()) {
      // Track back navigation event
      Mixpanel.track("RetireePortalButton.BackToLocation", {
        isLogged: UserService.isLoggedIn(),
      });

      const navigationSource = localStorage.getItem('retireeNavigationSource');

      if (navigationSource) {
        // Validate that the navigation source is safe (alphanumeric and hyphens only)
        const isValidRoute = /^[a-zA-Z0-9-]+$/.test(navigationSource);
        localStorage.removeItem('retireeNavigationSource');

        if (isValidRoute) {
          window.location.href = `${process.env.REACT_APP_MEMBER_PORTAL_URL}/${navigationSource}`;
        } else {
          // If invalid, redirect to home
          window.location.href = `${process.env.REACT_APP_MEMBER_PORTAL_URL}/`;
        }
      }
      return;
    }

    // Navigate to the Medicare portal (miiamedicare on production: REACT_APP_MEDICARE_URL)
    // Track navigation to retirees page
    Mixpanel.track("RetireePortalButton.NavigateToRetirees", {
      isLogged: UserService.isLoggedIn(),
    });

    // Build URL with query parameters instead of relying on localStorage
    const medicareUrl = new URL(process.env.REACT_APP_MEDICARE_URL);

    // Add retireeId as query parameter if available
    if (location?.retireeId) {
      medicareUrl.searchParams.set('retireeId', location.retireeId);
      // Still set in localStorage as fallback for same-origin scenarios
      localStorage.setItem('selectedRetireeId', location.retireeId);
    }

    // Add navigation source as query parameter if we're on a location page
    if (location?.uniqueNonGuessableId) {
      medicareUrl.searchParams.set('source', location.uniqueNonGuessableId);
      // Still set in localStorage as fallback for same-origin scenarios
      localStorage.setItem('retireeNavigationSource', location.uniqueNonGuessableId);
    } else {
      localStorage.removeItem('retireeNavigationSource');
    }

    console.log('Navigating to Medicare Portal:', medicareUrl.toString());
    window.location.href = medicareUrl.toString();
  };

  if (!shouldShowRetireePortalButton()) {
    return null;
  }

  return (
    <button
      style={{
        border: "none",
        width: "100%",
      }}
      onClick={handleClick}
      className="quickAccess-subtitle"
    >
      {isRetireesPage() ? "MIIA Member Portal" : "MIIA Medicare Portal"}
    </button>
  );
};

export default RetireePortalButton;